module.exports = __webpack_public_path__ + "static/img/02.edd5687.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_frauenfeld/02.jpg
// module id = 441
// module chunks = 1